export default function checkVat(vat: string) {
  return Boolean(vat.match('^([A-Za-z]{2})?[0-9]{8,}$'));
}
